import {Outlet, useLocation} from "react-router";

export default function EncounterWorkspace() {
    const {pathname} = useLocation();
    const map = pathname.replace(/\/$/, "").endsWith("/map");
    return <div className={`flex min-h-0 min-w-0 flex-1 flex-col bg-background${map ? "" : " p-3"}`}>
        <Outlet/>
    </div>;
}
